define('partlookup_partlookup.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('partlookup_partlookup', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-view=\"AssembliesList.View\"></div>";
},"useData":true}, 'extensions/StratosERP/CCSearch/1.0.0/', 'extensions/StratosERP/CCSearch/1.0.0/', Handlebars);
});